import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { Pill, fmtDate } from "@/components/hub/Common";
import { SuspendBtn } from "@/components/admin/UsersTab";

export const WorkspacesTab = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/workspaces").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (w) => {
    try { await api.post(`/admin/workspaces/${w.slug}/suspend`, { suspended: !w.suspended }); toast.success(t("adm.saved")); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="admin-workspaces">
      {list.map((w) => (
        <div key={w.slug} className="cx-card rounded-2xl p-5" data-testid={`admin-ws-${w.slug}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="font-display text-white truncate">{w.name}</div>
              <div className="font-mono text-xs text-slate-500 truncate">{w.slug}</div>
            </div>
            <Pill tone={w.suspended ? "declined" : "shipped"}>{w.suspended ? t("adm.suspended") : t("adm.active")}</Pill>
          </div>
          <div className="grid grid-cols-3 gap-2 mt-4 text-center">
            {[["members", w.members], ["s_videos", w.videos], ["s_clips", w.clips]].map(([k, v]) => (
              <div key={k} className="rounded-lg bg-white/[0.03] py-2"><div className="font-display text-lg text-white">{v}</div><div className="text-[10px] text-slate-500 uppercase">{t(`adm.${k}`)}</div></div>
            ))}
          </div>
          <div className="flex items-center justify-between mt-4 text-xs text-slate-500">
            <span>{fmtDate(w.created_at)}</span>
            {w.slug !== user?.tenant_id && <SuspendBtn testid={`admin-ws-suspend-${w.slug}`} suspended={w.suspended} onClick={() => toggle(w)} />}
          </div>
        </div>
      ))}
    </div>
  );
};
